// ignore-string-externalization
import React from 'react';
import styled from 'styled-components';
import { Supertext } from './Supertext';
import { Headline } from './Headline';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var HeadlineWithSupertext = styled.div.withConfig({
  displayName: "HeadlineWithSupertext",
  componentId: "sc-1bj1pww-0"
})(["background-color:", ";color:", ";"], function (_ref) {
  var background = _ref.background,
      theme = _ref.theme;
  return background ? background : theme.box.background;
}, function (_ref2) {
  var text = _ref2.text,
      theme = _ref2.theme;
  return text ? text : theme.box.text;
});
export var HeadlineWithSupertextComponent = function HeadlineWithSupertextComponent(_ref3) {
  var _ref3$supertext = _ref3.supertext,
      supertext = _ref3$supertext === void 0 ? '' : _ref3$supertext,
      _ref3$headline = _ref3.headline,
      headline = _ref3$headline === void 0 ? '' : _ref3$headline,
      _ref3$text = _ref3.text,
      text = _ref3$text === void 0 ? '' : _ref3$text,
      _ref3$background = _ref3.background,
      background = _ref3$background === void 0 ? '' : _ref3$background,
      _ref3$centered = _ref3.centered,
      centered = _ref3$centered === void 0 ? false : _ref3$centered;
  return /*#__PURE__*/_jsxs(HeadlineWithSupertext, {
    text: text,
    background: background,
    children: [/*#__PURE__*/_jsx(Supertext, {
      centered: centered,
      children: supertext
    }), headline && /*#__PURE__*/_jsx(Headline, {
      centered: centered,
      children: headline
    })]
  });
};